import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { FaAccessibleIcon } from "react-icons/fa";
import { FcCalendar } from "react-icons/fc";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";

export default function FilteredDate({
  open,
  setOpen,
  handleClickOpen,
  handleClose,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  moveOnReconciliationPage,
  themecolor,
  documnetType,
  setDocumentType,
}) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Select a Date for GST Reconciliation"}
        </DialogTitle>
        <DialogContent>
          <Grid item lg={6} md={6} sm={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                label="From"
                value={fromDate}
                margin="dense"
                format="dd/MM/yyyy"
                inputVariant="outlined"
                views={["year", "month", "date"]}
                onChange={(value) => setFromDate(value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <FcCalendar />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item lg={6} md={6} sm={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                label="To"
                value={toDate}
                margin="dense"
                format="dd/MM/yyyy"
                inputVariant="outlined"
                views={["year", "month", "date"]}
                onChange={(value) => setToDate(value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <FcCalendar />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1} textAlign="end">
            <Grid item xs={12}>
              <Button
                color="primary"
                variant="contained"
                style={{ background: themecolor }}
                onClick={() => moveOnReconciliationPage()}
              >
                Save
              </Button>
              <Button
                color="secondary"
                variant="contained"
                style={{ marginLeft: "20px" }}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
